// Picture-logo concepts for Alif Ba Club (viewBox 0 0 120 120, same line style as art.js)
const MARKS = {
  // 1. Book buddy: a happy open book with sparkles — reading & learning
  book: `<svg viewBox="0 0 120 120">
    <ellipse cx="60" cy="110" rx="40" ry="5" fill="#000" opacity=".07"/>
    <path d="M8 46 Q34 34 60 46 Q86 34 112 46 V102 Q86 90 60 102 Q34 90 8 102Z" fill="#FF7A59" ${S}/>
    <path d="M14 42 Q37 31 60 42 V96 Q37 85 14 96Z" fill="#fff" ${S}/>
    <path d="M106 42 Q83 31 60 42 V96 Q83 85 106 96Z" fill="#fff" ${S}/>
    <path d="M22 54 Q36 48 50 54 M22 64 Q36 58 50 64" fill="none" stroke="#C3ECE6" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 6"/>
    <path d="M70 54 Q84 48 98 54 M70 64 Q84 58 98 64" fill="none" stroke="#C3ECE6" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 6"/>
    ${EYE(40, 74)}${EYE(80, 74)}${BLUSH(31, 83)}${BLUSH(89, 83)}
    <path d="M54 83 q6 6 12 0" fill="none" ${S} stroke-width="2.6"/>
    <path d="${starPath(28, 20, 12, 5.5)}" fill="#FFC94A" ${S} stroke-width="1.6"/>
    <path d="${starPath(94, 16, 10, 4.5)}" fill="#2EB5A8" ${S} stroke-width="1.6"/>
    <path d="${starPath(61, 10, 7, 3.2)}" fill="#8B7BF5" ${S} stroke-width="1.4"/>
  </svg>`,

  // 2. Pencil pal: a smiling pencil tracing a dotted loop — writing & tracing
  pencil: `<svg viewBox="0 0 120 120">
    <path d="M18 92 C8 70 30 52 46 66 C60 78 40 98 26 86" fill="none" stroke="#2EB5A8" stroke-width="5" stroke-linecap="round" stroke-dasharray="0.1 10"/>
    <g transform="rotate(35 70 56)">
      <rect x="56" y="6" width="28" height="80" rx="6" fill="#FFC94A" ${S}/>
      <rect x="56" y="6" width="28" height="14" rx="6" fill="#FF8FA3" ${S}/>
      <rect x="56" y="18" width="28" height="7" fill="#C9CEDD" ${S} stroke-width="2.4"/>
      <path d="M56 86 L70 112 L84 86Z" fill="#F4D3A8" ${S}/>
      <path d="M65 102 L70 112 L75 102Z" fill="${INK}"/>
      ${EYE(64, 50)}${EYE(77, 50)}
      <path d="M65 60 q5 5 10 0" fill="none" ${S} stroke-width="2.4"/>
      ${BLUSH(60, 58)}${BLUSH(81, 58)}
    </g>
    <path d="${starPath(22, 24, 12, 5.5)}" fill="#FF7A59" ${S} stroke-width="1.6"/>
  </svg>`,

  // 3. Duck scholar: the duck from the workbooks, in a graduation cap — a mascot
  duck: `<svg viewBox="0 0 120 120">
    <ellipse cx="60" cy="112" rx="38" ry="5" fill="#000" opacity=".07"/>
    <path d="M22 80 q0 -22 30 -22 h22 q26 0 26 22 q0 26 -38 26 q-40 0 -40 -26z" fill="#FFD23F" ${S}/>
    <path d="M14 72 q6 10 14 8" fill="#FFD23F" ${S}/>
    <path d="M46 80 q14 14 30 0" fill="#F7B801" ${S}/>
    <circle cx="74" cy="44" r="22" fill="#FFD23F" ${S}/>
    <path d="M92 46 q16 -2 18 6 q-6 8 -20 4z" fill="#FF8C42" ${S}/>
    ${EYE(78, 40, 3.8)}${BLUSH(68, 52)}
    <path d="M50 22 L76 12 L102 22 L76 32Z" fill="${INK}" ${S}/>
    <path d="M62 26 V34 Q76 40 90 34 V26" fill="${INK}" ${S}/>
    <path d="M100 22 V36" stroke="#FFC94A" stroke-width="3" stroke-linecap="round"/>
    <circle cx="100" cy="38" r="3.5" fill="#FFC94A"/>
    <path d="${starPath(22, 30, 11, 5)}" fill="#2EB5A8" ${S} stroke-width="1.6"/>
  </svg>`,
};
